import { apiRequest } from "./apiRequest";
import { errorHandler } from "./errorHandler";

export const deleteUser = async (id: number): Promise<string> => {
  try {
    const data = await apiRequest<{ message: string }>(
      "delete",
      `/users/${id}`
    );
    return data.message;
  } catch (error) {
    errorHandler(error);
    throw new Error("Failed to delete user");
  }
};
